const errorsInTime = {
  hourError: (hour, minute) =>
    (hour.length === 1 && hour > 2 && minute.length >= 0) || hour > 23,
  minuteError: (_, minute) =>
    (minute.length === 1 && minute > 5) || minute > 59,
  lengthError: (hour, minute) => hour.length < 2 || minute.length < 2,
};

const validateTime = (time = '') => {
  const timeSplitted = (time || '').toString().split(':');
  const hour = timeSplitted[0] || '';
  const minute = timeSplitted[1] || '';

  if (!hour && !minute) {
    return {
      isValid: false,
      error: 'lengthError',
    };
  }

  return Object.keys(errorsInTime).reduce(
    (acc, key) => {
      if (!acc.isValid) {
        return acc;
      }

      if (errorsInTime[key](hour, minute)) {
        return {
          isValid: false,
          error: key,
        };
      }

      return acc;
    },
    { isValid: true, error: '' }
  );
};

export default validateTime;
